"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JoinPage = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../../hooks");
var _JoinComponent = require("../JoinComponent.styled");
var _constants = require("../../../constants");
var _PageNotification = require("../PageNotification/PageNotification");
var _PageTitle = require("../PageTitle/PageTitle");
var _PageBodyTop = require("../PageBodyTop/PageBodyTop");
var _PageFooter = require("../PageFooter/PageFooter");
var _VirtualBackground = require("@studio/constants/VirtualBackground");
var _GenericCameraPreview = require("../GenericCameraPreview/GenericCameraPreview");
var _PageBody = require("../PageBody/PageBody");
var _MicrophoneSelector = require("../PageBody/MicrophoneSelector");
var _CheckAudioOutput = require("../PageBody/CheckAudioOutput");
var _CameraSelectorSwitch = require("../PageBody/CameraSelectorSwitch");
var _VirtualBackgroundOptions = require("../VirtualBackgroundOptions/VirtualBackgroundOptions");
var _utils = require("../utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StudioLogger = require("@studio/logger/StudioLogger");
var _featureFlags = require("@studio/feature.flags/featureFlags");
var _useBackgroundFilterPageActionsApi = require("@studio/metrics/client/react/useBackgroundFilterPageActionsApi");
var _excluded = ["retryTest", "readinessCheck", "user", "userRole", "initializeBackgroundFilter", "joinMeeting", "uploadUserVirtualBackground", "resetUserVirtualBackground", "CameraPreviewElement", "sourceLoadStatus", "isJoinInProgress", "initializeVideoInput", "changeVideoInputDevice", "changeUserBackground"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t4 in e) "default" !== _t4 && {}.hasOwnProperty.call(e, _t4) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t4)) && (i.get || i.set) ? o(f, _t4, i) : f[_t4] = e[_t4]); return f; })(e, t); }
var LOG = new _StudioLogger.StudioLogger('join-page');
/**
 * JoinPage component for setting up user media devices and preferences before joining a meeting.
 *
 * @component
 * @param {Object} props - Component props
 * @param {Function} props.retryTest - Function to retry media device tests
 * @param {Object} props.readinessCheck - Object containing the status of device readiness checks
 * @param {Object} props.user - User information object
 * @param {Function} props.initializeBackgroundFilter - Function to initialize background blur filter
 * @param {Function} props.joinMeeting - Function to join the meeting with user configuration
 * @param {string} props.sourceLoadStatus - Status of source loading
 * @param {boolean} props.isJoinInProgress - Flag indicating if join process is in progress
 * @param {Function} [props.uploadUserVirtualBackground] - Optional function to upload custom virtual background
 * @param {Function} [props.resetUserVirtualBackground] - Optional function to reset custom virtual background
 * @param {React.Component} [props.CameraPreviewElement=GenericCameraPreview] - Component to use for camera preview
 * @param {Function} [props.initializeVideoInput] - Function to initialize video input device
 * @param {Function} [props.changeVideoInputDevice] - Function to change video input device
 * @param {Function} [props.changeUserBackground] - Function to change user background
 * @param {Object} props.additionalProps - Additional props to pass to child components
 * @returns {React.Element} Rendered component
 */
var JoinPage = exports.JoinPage = function JoinPage(_ref) {
  var _user$description, _virtualBackground$im, _selectedVideoInput$v;
  var retryTest = _ref.retryTest,
    readinessCheck = _ref.readinessCheck,
    user = _ref.user,
    userRole = _ref.userRole,
    initializeBackgroundFilter = _ref.initializeBackgroundFilter,
    joinMeeting = _ref.joinMeeting,
    uploadUserVirtualBackground = _ref.uploadUserVirtualBackground,
    resetUserVirtualBackground = _ref.resetUserVirtualBackground,
    _ref$CameraPreviewEle = _ref.CameraPreviewElement,
    CameraPreviewElement = _ref$CameraPreviewEle === void 0 ? _GenericCameraPreview.GenericCameraPreview : _ref$CameraPreviewEle,
    sourceLoadStatus = _ref.sourceLoadStatus,
    _ref$isJoinInProgress = _ref.isJoinInProgress,
    isJoinInProgress = _ref$isJoinInProgress === void 0 ? false : _ref$isJoinInProgress,
    initializeVideoInput = _ref.initializeVideoInput,
    changeVideoInputDevice = _ref.changeVideoInputDevice,
    changeUserBackground = _ref.changeUserBackground,
    additionalProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)({
      videoTrack: null,
      device: null,
      virtualBackground: _VirtualBackground.BACKGROUND_OPTIONS.NONE,
      virtualBackgroundImageUrl: ''
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selectedVideoInput = _useState2[0],
    setSelectedVideoInput = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    selectedAudioInput = _useState4[0],
    setSelectedAudioInput = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    selectedAudioOutput = _useState6[0],
    setSelectedAudioOutput = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    userBackgroundLoading = _useState8[0],
    setUserBackgroundLoading = _useState8[1];
  var shouldRequireAudio = (0, _featureFlags.shouldHaveFeature)('studio.requireAudio');
  var virtualBackground = user === null || user === void 0 ? void 0 : user.virtualBackground;
  var _useState9 = (0, _react.useState)("".concat((user === null || user === void 0 ? void 0 : user.firstName) || '', " ").concat((user === null || user === void 0 ? void 0 : user.lastName) || '')),
    _useState0 = (0, _slicedToArray2["default"])(_useState9, 2),
    presenterTitle = _useState0[0],
    setPresenterTitle = _useState0[1];
  var _useState1 = (0, _react.useState)((_user$description = user === null || user === void 0 ? void 0 : user.description) !== null && _user$description !== void 0 ? _user$description : ''),
    _useState10 = (0, _slicedToArray2["default"])(_useState1, 2),
    presenterDescription = _useState10[0],
    setPresenterDescription = _useState10[1];
  var _useJoinComponentStat = (0, _hooks.useJoinComponentStates)({
      shouldRequireAudio: shouldRequireAudio,
      readinessCheck: readinessCheck,
      userRole: userRole,
      isStandaloneChecker: false,
      shouldJoinWithoutKnock: false
    }),
    checkStatus = _useJoinComponentStat.checkStatus,
    currentPage = _useJoinComponentStat.currentPage,
    errors = _useJoinComponentStat.errors,
    warnings = _useJoinComponentStat.warnings,
    notification = _useJoinComponentStat.notification,
    setCurrentPage = _useJoinComponentStat.setCurrentPage;
  var _useBackgroundFilterP = (0, _useBackgroundFilterPageActionsApi.useBackgroundFilterPageActionsApi)(),
    startAttendeeBackgroundFilterChangeLatency = _useBackgroundFilterP.startAttendeeBackgroundFilterChangeLatency,
    endAttendeeBackgroundFilterChangeLatency = _useBackgroundFilterP.endAttendeeBackgroundFilterChangeLatency;
  var noErrorOrWarning = errors.length === 0 && warnings.length === 0;
  var _useGetMediaDevices = (0, _hooks.useGetMediaDevices)({
      video: true
    }),
    videoInputDevices = _useGetMediaDevices.videoInputDevices;
  var _useGetMediaDevices2 = (0, _hooks.useGetMediaDevices)({
      audio: true
    }),
    audioInputDevices = _useGetMediaDevices2.audioInputDevices,
    audioOutputDevices = _useGetMediaDevices2.audioOutputDevices;
  var backgroundUrl = (_virtualBackground$im = virtualBackground === null || virtualBackground === void 0 ? void 0 : virtualBackground.imageURL) !== null && _virtualBackground$im !== void 0 ? _virtualBackground$im : '';
  (0, _react.useEffect)(function () {
    if (!backgroundUrl && selectedVideoInput.virtualBackground === _VirtualBackground.BACKGROUND_OPTIONS.CUSTOM && selectedVideoInput.virtualBackgroundImageUrl) {
      onVirtualBackgroundChange(_VirtualBackground.BACKGROUND_OPTIONS.CUSTOM, backgroundUrl);
    }
  }, [backgroundUrl]);
  (0, _react.useEffect)(function () {
    var load = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _videoInputDevices$, selectedDeviceId, _videoInput, _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(selectedVideoInput.device === null && videoInputDevices.length > 0)) {
                _context.next = 4;
                break;
              }
              selectedDeviceId = (_videoInputDevices$ = videoInputDevices[0]) === null || _videoInputDevices$ === void 0 ? void 0 : _videoInputDevices$.value;
              if (!selectedDeviceId) {
                _context.next = 4;
                break;
              }
              _context.prev = 1;
              _context.next = 2;
              return initializeVideoInput(selectedDeviceId);
            case 2:
              _videoInput = _context.sent;
              setSelectedVideoInput(_videoInput);
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              LOG.error('Error initializing video input:', _t);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 3]]);
      }));
      return function load() {
        return _ref2.apply(this, arguments);
      };
    }();
    load();
  }, [videoInputDevices, selectedVideoInput]);
  (0, _react.useEffect)(function () {
    if (selectedAudioInput === null && audioInputDevices.length > 0) {
      var _audioInputDevices$;
      var selectedAudioDeviceId = (_audioInputDevices$ = audioInputDevices[0]) === null || _audioInputDevices$ === void 0 ? void 0 : _audioInputDevices$.value;
      if (selectedAudioDeviceId) {
        setSelectedAudioInput(selectedAudioDeviceId);
      }
    }
  }, [audioInputDevices, selectedAudioInput]);
  (0, _react.useEffect)(function () {
    if (selectedAudioOutput === null && audioOutputDevices.length > 0) {
      var _audioOutputDevices$;
      var selectedAudioOutputId = (_audioOutputDevices$ = audioOutputDevices[0]) === null || _audioOutputDevices$ === void 0 ? void 0 : _audioOutputDevices$.value;
      if (selectedAudioOutputId) {
        setSelectedAudioOutput(selectedAudioOutputId);
      }
    }
  }, [audioOutputDevices, selectedAudioOutput]);
  var join = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var allData;
      return _regenerator["default"].wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            allData = {
              presenterTitle: presenterTitle,
              presenterDescription: presenterDescription,
              selectedVideoInput: selectedVideoInput,
              selectedAudioInput: selectedAudioInput
            };
            LOG.info('Joining with data:', {
              presenterTitle: presenterTitle,
              presenterDescription: presenterDescription,
              selectedVideoInput: {
                device: selectedVideoInput.device,
                virtualBackground: selectedVideoInput.virtualBackground,
                virtualBackgroundImageUrl: selectedVideoInput.virtualBackgroundImageUrl
              },
              selectedAudioInput: selectedAudioInput
            });
            joinMeeting(allData);
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function join() {
      return _ref3.apply(this, arguments);
    };
  }();
  var onVideoInputChange = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(videoInputDevice) {
      var _videoInput, _t2;
      return _regenerator["default"].wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            setUserBackgroundLoading(true);
            _context3.next = 1;
            return changeVideoInputDevice(selectedVideoInput, videoInputDevice);
          case 1:
            _videoInput = _context3.sent;
            setSelectedVideoInput(_videoInput);
            _context3.next = 3;
            break;
          case 2:
            _context3.prev = 2;
            _t2 = _context3["catch"](0);
            LOG.error('Error updating video input:', _t2);
          case 3:
            _context3.prev = 3;
            setUserBackgroundLoading(false);
            return _context3.finish(3);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 2, 3, 4]]);
    }));
    return function onVideoInputChange(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  var onVirtualBackgroundChange = /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(backgroundOption) {
      var url,
        _videoInput,
        _args4 = arguments,
        _t3;
      return _regenerator["default"].wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            url = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : backgroundUrl;
            _context4.prev = 1;
            setUserBackgroundLoading(true);
            startAttendeeBackgroundFilterChangeLatency({
              filterTypeBefore: selectedVideoInput.virtualBackground,
              filterTypeAfter: backgroundOption
            });
            _context4.next = 2;
            return changeUserBackground(selectedVideoInput, backgroundOption, url);
          case 2:
            _videoInput = _context4.sent;
            setSelectedVideoInput(_videoInput);
            endAttendeeBackgroundFilterChangeLatency();
            _context4.next = 4;
            break;
          case 3:
            _context4.prev = 3;
            _t3 = _context4["catch"](1);
            endAttendeeBackgroundFilterChangeLatency({
              error: "Error updating virtual background : ".concat(_t3.message)
            });
            LOG.error('Error updating virtual background:', _t3);
          case 4:
            _context4.prev = 4;
            setUserBackgroundLoading(false);
            return _context4.finish(4);
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[1, 3, 4, 5]]);
    }));
    return function onVirtualBackgroundChange(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();
  var disableInput = readinessCheck.microphone === _constants.PERMISSION_DENIED;
  var disableVideoInput = (videoInputDevices === null || videoInputDevices === void 0 ? void 0 : videoInputDevices.length) === 1 && videoInputDevices[0].value === '' || userBackgroundLoading || disableInput;
  var hasAudioDevice = audioInputDevices.length > 0;
  var hasTitle = presenterTitle.trim().length > 0;
  var _getUserNameFromPrese = (0, _utils.getUserNameFromPresenterTitle)(presenterTitle),
    firstName = _getUserNameFromPrese.firstName,
    lastName = _getUserNameFromPrese.lastName;
  var hasFirstNameExceededLimit = firstName.trim().length > 30;
  var hasLastNameExceededLimit = lastName.trim().length > 50;
  var hasDescriptionExceededLimit = presenterDescription.trim().length > 80;
  var hasValidationError = !hasTitle || hasFirstNameExceededLimit || hasLastNameExceededLimit || hasDescriptionExceededLimit;
  var _userBackground = (_selectedVideoInput$v = selectedVideoInput === null || selectedVideoInput === void 0 ? void 0 : selectedVideoInput.virtualBackground) !== null && _selectedVideoInput$v !== void 0 ? _selectedVideoInput$v : _VirtualBackground.BACKGROUND_OPTIONS.NONE;
  var hasCamera = (0, _utils.hasCameraDevices)(videoInputDevices);
  return /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledGenericCard, {
    className: "shadow-sm",
    "data-testid": "join-page"
  }, /*#__PURE__*/_react["default"].createElement(_PageNotification.PageNotification, {
    key: notification.id,
    noErrorOrWarning: noErrorOrWarning,
    notification: notification
  }), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardBody, null, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardTitleContainer, null, /*#__PURE__*/_react["default"].createElement(_PageTitle.PageTitle, {
    page: currentPage
  })), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledSettingsComponentContent, null, /*#__PURE__*/_react["default"].createElement(_PageBodyTop.PageBodyTop, {
    currentPage: currentPage,
    checkStatus: checkStatus,
    errors: errors,
    warnings: warnings
  }), /*#__PURE__*/_react["default"].createElement(_PageBody.PageBody, {
    presenterTitle: presenterTitle,
    presenterDescription: presenterDescription,
    checkStatus: checkStatus,
    setPresenterTitle: setPresenterTitle,
    setPresenterDescription: setPresenterDescription,
    readinessCheck: readinessCheck,
    microphoneSelector: /*#__PURE__*/_react["default"].createElement(_MicrophoneSelector.MicrophoneSelector, {
      selectedAudioInputDevice: selectedAudioInput,
      audioInputDevices: audioInputDevices,
      onMicrophoneChange: setSelectedAudioInput,
      disabled: disableInput
    }),
    checkAudioOutput: /*#__PURE__*/_react["default"].createElement(_CheckAudioOutput.CheckAudioOutput, {
      audioOutputDevice: selectedAudioOutput,
      disabled: disableInput
    }),
    cameraSelector: /*#__PURE__*/_react["default"].createElement(_CameraSelectorSwitch.CameraSelectorSwitch, {
      selectedVideoInput: selectedVideoInput,
      videoInputDevices: videoInputDevices,
      onCameraChange: onVideoInputChange,
      disabled: disableVideoInput,
      initializeBackgroundFilter: initializeBackgroundFilter
    }, hasCamera && /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundOptions.VirtualBackgroundOptions, {
      userBackground: _userBackground,
      updateUserBackground: onVirtualBackgroundChange,
      uploadUserVirtualBackground: uploadUserVirtualBackground,
      virtualBackground: virtualBackground,
      resetUserVirtualBackground: resetUserVirtualBackground,
      isCustomBackgroundProcessing: userBackgroundLoading
    })),
    cameraPreview: /*#__PURE__*/_react["default"].createElement(CameraPreviewElement, (0, _extends2["default"])({
      videoInputDevice: selectedVideoInput,
      presenterTitle: presenterTitle,
      presenterDescription: presenterDescription,
      checkStatus: checkStatus
    }, additionalProps)),
    currentPage: currentPage
  })), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardFooter, null, /*#__PURE__*/_react["default"].createElement(_PageFooter.PageFooter, {
    userBackgroundLoading: userBackgroundLoading,
    currentPage: currentPage,
    checkStatus: checkStatus,
    errors: errors,
    hasValidationError: hasValidationError,
    hasAudioDevice: hasAudioDevice,
    isStandaloneChecker: false,
    sourceLoadStatus: sourceLoadStatus,
    goToPage: setCurrentPage,
    runSystemCheck: retryTest,
    handleJoinMeeting: join,
    isJoinInProgress: isJoinInProgress
  }))));
};
JoinPage.propTypes = {
  retryTest: _propTypes["default"].func.isRequired,
  readinessCheck: _propTypes["default"].object.isRequired,
  user: _propTypes["default"].object.isRequired,
  userRole: _propTypes["default"].string,
  initializeBackgroundFilter: _propTypes["default"].func.isRequired,
  joinMeeting: _propTypes["default"].func.isRequired,
  getVideoInput: _propTypes["default"].func.isRequired,
  clearVirtualBackground: _propTypes["default"].func.isRequired,
  CameraPreviewElement: _propTypes["default"].elementType,
  sourceLoadStatus: _propTypes["default"].string,
  isJoinInProgress: _propTypes["default"].bool,
  additionalProps: _propTypes["default"].object,
  initializeVideoInput: _propTypes["default"].func.isRequired,
  changeVideoInputDevice: _propTypes["default"].func.isRequired,
  changeUserBackground: _propTypes["default"].func.isRequired,
  uploadUserVirtualBackground: _propTypes["default"].func,
  resetUserVirtualBackground: _propTypes["default"].func
};